var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('page-section', {
    staticClass: "py-0",
    scopedSlots: _vm._u([{
      key: "pageSectionImmersive",
      fn: function fn() {
        return [_c('v-row', {
          attrs: {
            "no-gutters": ""
          }
        }, [_c('v-col', {
          attrs: {
            "cols": "12",
            "lg": "6",
            "order-lg": _vm.reverse ? 2 : 1,
            "data-aos": "fade",
            "data-aos-delay": "200"
          }
        }, [_c('v-img', {
          attrs: {
            "max-height": _vm.$vuetify.breakpoint.lgAndUp ? 980 : 300,
            "height": "100%",
            "src": _vm.imageSrc
          }
        })], 1), _c('v-col', {
          attrs: {
            "cols": "12",
            "lg": "6",
            "align-self": "center",
            "order-lg": _vm.reverse ? 1 : 2
          }
        }, [_c('div', {
          staticClass: "d-flex align-center justify-center px-12px pt-40px pb-60px px-md-40px pt-md-40px pb-md-80px py-lg-80px"
        }, [_c('div', {
          style: _vm.$vuetify.breakpoint.lgAndUp ? 'max-width: 588px;' : '',
          attrs: {
            "data-aos": "fade-up",
            "data-aos-delay": "300"
          }
        }, [_c('v-divider', {
          staticClass: "grey darken-4"
        }), _c('div', {
          staticClass: "py-20px py-md-40px py-xl-80px"
        }, [_c('div', {
          staticClass: "tit-wrap tit-wrap--sm"
        }, [_vm._t("title")], 2), _c('div', {
          staticClass: "txt txt--xl"
        }, [_vm._t("text")], 2)]), _c('v-divider', {
          staticClass: "grey darken-4"
        })], 1)])])], 1)];
      },
      proxy: true
    }], null, true)
  });
}
var staticRenderFns = []

export { render, staticRenderFns }